export const getEnv = (key) => {
  return window.ac_env ? window.ac_env[key] : "NO_ENV_DEFINED";
};

export const ENV = getEnv("ENV");
export const ACCOUNTS_SERVICE_URI = getEnv("ACCOUNTS_SERVICE_URI");
export const BASE_DOMAIN = getEnv("BASE_DOMAIN");
export const FRAUD_SERVICE_URI = getEnv("FRAUD_SERVICE_URI");
export const KYC_MAX_POLL_ATTEMPTS = getEnv("KYC_MAX_POLL_ATTEMPTS");
export const KYC_POLL_INTERVAL = getEnv("KYC_POLL_INTERVAL");
export const MOOV_FED_SERVICE_URI = getEnv("MOOV_FED_SERVICE_URI");
export const PAYMENTS_SERVICE_URI = getEnv("PAYMENTS_SERVICE_URI");
export const INVOICING_SERVICE_URI = getEnv("INVOICING_SERVICE_URI");
export const PII_SERVICE_URI = getEnv("PII_SERVICE_URI");
export const ROUTE_BASENAME = "/ui";
export const TILIA_DOMAIN = getEnv("TILIA_DOMAIN");
export const TILIA_PRIVACY_URL = getEnv("TILIA_PRIVACY_URL");
export const TILIA_SUPPORT_URL = getEnv("TILIA_SUPPORT_URL");
export const TILIA_TOS_URL = getEnv("TILIA_TOS_URL");
